import { GetterTree } from "vuex";
import { INewsState } from "@/core/interfaces/news.interface";
import { StoreState } from "@/store/type";

const getters: GetterTree<INewsState, StoreState> = {
  isNewsLoading: (state) => state.isNewsLoading,
  newsData: (state) => state.news,
};

export default getters;
